import { Button } from "@/components";
import { useLogout } from "@/app/modules/User/hooks/useLogout.tsx";
import { useTranslate, useUser } from "@/providers/context";
import { useNavigate } from "react-router-dom";

export const SignInOutButton = () => {
  const logout = useLogout();
  const { uid } = useUser();
  const isSignedIn = !!uid;
  const navigate = useNavigate();
  const { translate } = useTranslate();

  return (
    <>
      {isSignedIn ? (
        <Button
          size="m"
          variant="secondary"
          className="mt-[72px] w-[207px] capitalize"
          onClick={() => logout.mutate({ user_id: uid ?? "" })}
          loading={logout.isLoading}
        >
          {translate("Sign Out")}
        </Button>
      ) : (
        <Button
          size="m"
          className="mt-[72px] w-[207px] capitalize"
          onClick={() => navigate("/sign-in")}
        >
          {translate("Sign in")}
        </Button>
      )}
    </>
  );
};
